export const storeProducts = [
  {
    new: false,
    id: 1,
    title: "CHELSEY DRESS",
    type: "dress",
    img: "img/dresses/chelsey.jpg",
    price: 135,
    company: "I.AM.GIA.",
    info:
      "Fitted corset style mini dress. Corset upper with boning. Flattering puff sleeve with inner elasticated sleeve.Centre back invisible coil zip entry. Dark denim stretch-fit fabrication. Dark tan GIA embroidery at hem. Main fabric: 80% cotton 15% polyester 5% spandex. Lining fabric: 60% cotton 35% nylon 5% spandex. Bruna is wearing a size XS",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/chelsey-dress-blue"
  },
  {
    new: false,
    id: 2,
    title: "MOLLY DRESS",
    img: "img/dresses/molly.jpg",
    price: 135,
    type: "dress",
    company: "I.AM.GIA.",
    info:
      " Black long sleeve mini dress. Fitted style. Eyelets down the front and princess seams. Skin can be seen through eyelets. V-neck with collar and frills. Pleated skirt. Workable press studs on sleeve cuffs. Invisible zip in side seam. Bruna wears size XS",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/molly-dress-black"
  },
  {
    new: true,
    id: 3,
    title: "CERES DRESS",
    img: "img/dresses/ceres.jpg",
    price: 99,
    type: "dress",
    company: "I.AM.GIA.",
    info:
      "  Orange mesh mini dress. Ruched seam detail on sides. High razor cut neckline. Reflective oil spill print on front. Orange slip dress included. Mesh Dress: 93% Polyester, 7% Spandex. Slip: 95% Polyester, 5% Spandex. Model wears size XS ",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/raquelle-dress-orange"
  },
  {
    new: false,
    id: 4,
    title: "SCEPTRUM DRESS",
    img: "img/dresses/sceptrum.jpg",
    type: "dress",
    price: 144,
    company: "I.AM.GIA.",
    info:
      "    Black strapless buckle dress.  Bodycon fit. Contrast white stitching. Multi buckle feature on sides. Silver hardware. Zip closure on back. Bruna wears a size XS",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/sceptrum-dress-black"
  },
  {
    new: false,
    id: 5,
    title: "Black T-Shirt Dress",
    img: "img/dresses/vetementsdress.jpg",
    price: 1424,
    company: "Vetements",
    type: "dress",
    info:
      '    Short sleeve cotton jersey mid-length dress in black. Panelled construction. Rib knit crewneck collar. Graphics printed in white at front and back. Vented hem. Tonal embroidered logo at back.  ',
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.ssense.com/en-ca/women/product/vetements/black-t-shirt-dress/4161761"
  },
  {
    new: false,
    id: 6,
    title: "Navy Logo Mini Dress",
    img: "img/dresses/navy.jpg",
    price: 317,
    company: "Opening Ceremony",
    type: "dress",
    info:
      "    Sleeveless stretch viscose and nylon-blend jersey dress in navy. Square neckline. Logo woven in black and white at straps and front.",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.ssense.com/en-ca/women/product/opening-ceremony/navy-logo-mini-dress/3960881"
  },
  {
    new: false,
    id: 7,
    title: "Yellow Lingerie Wrap Dress",
    img: "img/dresses/neondress.jpg",
    price: 2275,
    company: "VETEMENTS",
    type: "dress",
    info: "Sleeveless stretch nylon-blend jersey mid-length dress in yellow. Tonal lace trim throughout. Integrated tonal shawl-style panel with cut-out. ",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.ssense.com/en-ca/women/product/msgm/black-fleece-multi-logo-dress/3989061"
  },
  {
    new: false,
    id: 8,
    title: "Black Fleece Mulit Logo Dress",
    img: "img/dresses/msgm.jpg",
    price: 445,
    company: "MSGM",
    type: "dress",
    info:
      '    Long sleeve cotton fleece short dress in black. Rib knit crewneck collar, cuffs, and hem. Logo printed in red at waist. Text printed in white at sleeve. Logo printed in white at back. ',
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.ssense.com/en-ca/women/product/msgm/black-fleece-multi-logo-dress/3989061"
  },
  {
    new: false,
    id: 9,
    title: "Off-White Silk Opi Print Shirt",
    img: "img/tops/silkshirt.jpg",
    price: 3195,
    type: "top",
    company: "Marni",
    info: "Long sleeve silk twill shirt in off-white featuring multicolor graphics throughout. Fringed detailing at spread collar and single-button barrel cuffs. Button closure and embroidered multicolor detailing at front. Patch pocket at chest. Raw edge at shirttail hem. Box pleat at back. "
    , inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/naomi-top-white"
  }
  ,
  {
    new: false,
    id: 10,
    title: "Black Leather Corset",
    img: "img/tops/corset.jpg",
    price: 2995,
    type: "top",
    company: "Alexander McQueen",
    info: "Structured panelled buffed calfskin corset in black. Adjustable leather pin-buckle straps at waist. Zip closure at back. Silver-tone hardware.",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/naomi-top-white"
  }
  ,
  {
    new: true,
    id: 11,
    title: "Multicolor Check Overshirt",
    img: "img/tops/palmAngels.jpg",
    price: 1550,
    type: "top",
    company: "Palm Angels",
    info: "Long sleeve wool-blend twill shirt in red featuring multicolor check pattern woven throughout. Spread collar. Zip closure at front. Flap pockets at chest. White and black logo and graphic patches at waist. Zippered vents at sleeves. Single-button barrel cuffs. White rubberized logo bonded at back. Silver-tone hardware. "
    , inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/naomi-top-white"
  }
  ,
  {
    new: false,
    id: 12,
    title: "SSENSE Exclusive White Leather Kumbi Top",
    img: "img/tops/leathertop.jpg",
    price: 2000,
    type: "top",
    company: "Mowalola",
    info: "Long sleeve grained leather jacket in white featuring tie-dye-style detailing in tones of burgundy throughout. Press-stud tab fastening at stand collar. Off-set zip closure at front. Integrated shoulder pads. Zippered vent at cuffs. Cut-out at back. Lined. Silver-tone hardware.",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/naomi-top-white"
  }
  ,
  {
    new: false,
    id: 13,
    title: "NAomi TOP",
    img: "img/tops/naomi.jpg",
    price: 91,
    type: "top",
    company: "I.AM.GIA.",
    info:
      "White bustier style top. Off shoulder sheer puff sleeve. True tie at front. Side seam zipper. 95% cotton, 5% spandex. Bruna wears size XS",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/holly-top-white"
  }
  ,
  {
    new: false,
    id: 14,
    title: "Beige Military Shirt",
    img: "img/tops/burbs.jpg",
    price: 1020,
    type: "top",
    company: "Burberry",
    info: "Short sleeve cotton twill shirt in 'honey' beige. Logo and text printed in red throughout. Spread collar. Half-zip closure at front. Patch pockets at chest. Silver-tone hardware.   ",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/holly-top-white"
  }
  ,
  {
    new: true,
    id: 15,
    title: "HOLLY TOP",
    img: "img/tops/holly.jpg",
    price: 91,
    type: "top",
    company: "I.AM.GIA.",
    info:
      "White bustier style top. Off shoulder sheer puff sleeve. True tie at front. Side seam zipper. 95% cotton, 5% spandex. Bruna wears size XS",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/holly-top-white"
  }
  ,
  {
    new: false,
    id: 16,
    title: "SSENSE Exclusive Multilogo Sporty Top",
    img: "img/tops/sporty-top.jpg",
    price: 91,
    type: "top",
    company: "Off-White",
    info: "Long sleeve stretch viscose and nylon-blend jersey t-shirt in black. Logo graphics printed in multicolor throughout. Tonal logo knit at mock neck collar.",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/holly-top-white"
  }
  ,
  {
    new: false,
    id: 17,
    title: "COBAIN Pant ",
    img: "img/bottoms/cobain.jpg",
    price: 99,
    type: "bottom",
    company: "I.AM.GIA.",
    info:
      "Tan cargo pant. High waist design . Semi relaxed fit . Chain detail . Cuffed hem. Poly/cotton blend. Bruna wears a size XS. Height: 178cm . Waist: 58cm . Hip: 86cm",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/cobain-pant-tan"
  }
  ,
  {
    new: true,
    id: 18,
    title: "Octavia Pant",
    img: "img/bottoms/octavia.jpg",
    price: 180,
    type: "bottom",
    company: "I.AM.GIA.",
    info:
      '  Black and orange moto pant. Detailed contrast panels. High rise. Straight leg. Front zip. Bruna wears size XS ',
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/octavia-pant"
  }
  ,
  {
    new: true,
    id: 19,
    title: "Electrica Pant",
    img: "img/bottoms/electrica.jpg",
    price: 191,
    type: "bottom",
    company: "I.AM.GIA.",
    info:
      "Red, black and white moto pants. Panel detailing with reflective piping. Logo graphic stripe down side leg. Elastic ankle cuffs. Built in side belt buckle. 95% Polyester 5% Spandex. Bruna wears size XS",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/electra-pant-red-black-white"
  }
  ,
  {
    new: false,
    id: 20,
    title: "Blaster Pant",
    img: "img/bottoms/blaster.jpg",
    price: 180,
    type: "bottom",
    company: "I.AM.GIA.",
    info:
      "Tracksuit pant. Colour block panels . High waist fit. Cuffed hem . Slogan detailing on sides . Cotton/Polyester. Styled with the Blaster jacket. Bruna wears a size XS",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/blaster-pant-black"
  }
  ,
  {
    new: false,
    id: 21,
    title: "Black SOTO Hand-Bleached C Jeans  ",
    img: "img/bottoms/bleachedjeans.jpg",
    price: 1375,
    type: "bottom",
    company: "S.R. STUDIO. LA. CA.",
    info: "Slim-fit non-stretch denim jeans in black. Fading and hand-bleached effect throughout. Mid-rise. Five-pocket styling. Belt loops at waistband. Logo patch in black at front waistband. Leather logo patch in black at back waistband. Button-fly. Gunmetal-tone hardware. ",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/electra-pant-red-black-white"
  }
  ,
  {
    new: false,
    id: 22,
    title: "Blue Skirt Jeans",
    img: "img/bottoms/skort.jpg",
    price: 1325,
    type: "bottom",
    company: "Sacai",
    info: "Slim-fit deconstructed non-stretch denim jeans in blue featuring denim and pleated twill skirt-style overlay in blue and green. Mid-rise. Fading and raw edges throughout. Five-pocket styling. Belt loops with nylon cinch belt in green at waistband. Rip at knees. Webbing cinch fastening at outseam. Zip-fly. Silver-tone hardware. Contrast stitching in tan.",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/electra-pant-red-black-white"
  }
  ,
  {
    new: false,
    id: 23,
    title: "SSENSE Exclusive Black Leather Touch Trousers",
    img: "img/bottoms/leather.jpg",
    price: 2425,
    type: "bottom",
    company: "Mowalola",
    info: "Slim-fit grained leather trousers in black. Low-rise. Graphic printed in tones of brown and black at front. Exposed zip-fly. Silver-tone hardware. ",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/electra-pant-red-black-white"
  }
  ,
  {
    new: false,
    id: 24,
    title: "Red Chenille Drawstring Lounge Pants",
    img: "img/bottoms/gucci.jpg",
    price: 1750,
    type: "bottom",
    company: "Gucci",
    info: "Relaxed-fit cotton and nylon-blend chenille lounge pants in tones of red. Mid-rise. Two-pocket styling. Drawstring at elasticized waistband. Embroidered logo patch in green, off-white, and red at front. Piping in off-white at front and back. Rib knit cuffs in brown.",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://iamgia.com/products/electra-pant-red-black-white"
  }
  ,
  {
    new: true,
    id: 25,
    title: "Red Wiggle Earrings",
    img: "img/accessories/redearring.jpg",
    price: 655,
    type: "accessories",
    company: "Simone Rocha",
    info: "Pair of drop earrings in gold-tone metal. Crystal-cut detailing in red throughout. Post-stud fastening. Approx. 3.5inch length. ",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.dollskill.com/azalea-wang-rose-clear-heels.html"
  }
  ,
  {
    new: false,
    id: 26,
    title: "Multicolor Floral Rugby Bucket Hat",
    img: "img/accessories/buckethat.jpg",
    price: 105,
    type: "accessories",
    company: "Noah NYC",
    info: "'Practice cloth' cotton jersey bucket hat in light blue featuring floral graphic printed in multicolor throughout. Quilted brim. Tonal logo embroidered at face. Embroidered eyelet detailing at sides. Approx. 2in brim length.",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.dollskill.com/azalea-wang-rose-clear-heels.html"
  }
  ,
  {
    new: false,
    id: 27,
    title: "Rose Clear Heels",
    img: "img/accessories/clearheels.jpg",
    price: 90,
    type: "accessories",
    company: "Azalea Wang",
    info:
      "Nude. Man-Made Materials.    4.25.  These BBz are in U.S. sizing; peep the size chart for ur perfect fit!",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.dollskill.com/azalea-wang-rose-clear-heels.html"
  }
  ,
  {
    new: false,
    id: 28,
    title: "bossy bloodline platform boots",
    img: "img/accessories/bloodlineboots.jpg",
    price: 90,
    type: "accessories",
    company: "PosterGirl",
    info:
      "BLUE SNAKE.      Man Made Materials.      5.5 inch Heel.      2.25 inch Platform. These BBz are in U.S. sizing; peep the size chart for ur perfect fit!",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.dollskill.com/poster-grl-platform-ankle-boots-blue-snakeskin.html"
  }
  ,
  {
    new: false,
    id: 29,
    title: "Croc Booties",
    img: "img/accessories/crocboots.jpg",
    price: 90,
    type: "accessories",
    company: "Azalea Wang",
    info:
      "White. Man Made Materials. 4 inch Heel. These BBz are in U.S. sizing; peep the size chart for ur perfect fit!",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.dollskill.com/croc-booties-white.html"
  }
  ,
  {
    new: false,
    id: 30,
    title: "CAdet lock necklace",
    img: "img/accessories/locknecklace.jpg",
    price: 20,
    type: "accessories",
    company: "PosterGirl",
    info:
      "Silver.      Man Made Materials",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.dollskill.com/azalea-wang-rose-clear-heels.html"
  }
  ,
  {
    new: false,
    id: 31,
    title: "Sapphire choker set",
    img: "img/accessories/bluechoker.jpg",
    price: 10,
    type: "accessories",
    company: "PosterGirl",
    info:
      "Blue.    Man Made Materials",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.dollskill.com/azalea-wang-rose-clear-heels.html"
  }
  ,
  {
    new: false,
    id: 32,
    title: "SSENSE Leather Fire Bucket Hat",
    img: "img/accessories/fire.jpg",
    price: 10,
    type: "accessories",
    company: "Marine Serre",
    info:"Grained leather bucket hat in black. Graphic pattern in tones of orange and yellow printed throughout. Tonal browband. Approx. 2.25in brim. ",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.dollskill.com/azalea-wang-rose-clear-heels.html"
  }
  ,
  {
    new: false,
    id: 33,
    title: "Pink Down puffer jacket",
    img: "img/outerwear/pinkpuffer.jpg",
    price: 2750,
    type: "outerwear",
    company: "Vetements",
    info:
      "Long sleeve down-filled quilted technical satin jacket in pink. Stowaway hood with bungee-style drawstring and tonal embroidered logo at funnel neck collar. Press-stud closure at front. Welt pockets at waist. Bungee-style drawstring at cuffs and hem. Welt pockets at interior. Concealed zip closure at hem for alternate styling. Black hardware. ",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.ssense.com/en-ca/women/product/vetements/pink-down-puffer-jacket/4161541"
  }
  ,
  {
    new: false,
    id: 34,
    title: "Blue denim Asymmetrical JAcket",
    img: "img/outerwear/denimblazer.jpg",
    price: 450,
    type: "outerwear",
    company: "Marques Almeida",
    info:
      "Long sleeve faded non-stretch denim jacket in blue. Frayed edge at crewneck collar and hem. Safety-pin fastening at front. Flap pockets at chest. Press-stud fastening at cuffs. Silver-tone hardware. Contrast stitching in tan.",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.ssense.com/en-ca/women/product/marques-almeida/blue-denim-asymmetric-jacket/4032361"
  }
  ,

  {
    new: false,
    id: 35,
    title: "Black Hand-bleached denim JAcket",
    img: "img/outerwear/bleacheddenim.jpg",
    price: 1950,
    type: "outerwear",
    company: "S.R. STUDIO",
    info:
      "Long sleeve non-stretch denim jacket in black. Fading and hand-bleached effect throughout. Spread collar. Button closure at front. Patch pockets and textile logo patch in orange at waist. Patch pocket at sleeve. Pleats at back. Silver-tone hardware. ",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.ssense.com/en-ca/women/product/sterling-ruby-studio/black-soto-denim-hand-bleached-cropped-jacket/4041421"
  }
  ,

  {
    new: false,
    id: 36,
    title: "Red Denim Slim Fit Shirt",
    img: "img/outerwear/redshirt.jpg",
    price: 850,
    type: "outerwear",
    company: "Raf Simons",
    info: "    Long sleeve non-stretch denim shirt in red. Spread collar. Button closure at front. Leather logo patch at chest. Two-button barrel cuffs. Logo-engraved silver-tone hardware. "
    , inCart: false,
    count: 0,
    total: 0,
    url: "https://www.ssense.com/en-ca/women/product/sterling-ruby-studio/black-soto-denim-hand-bleached-cropped-jacket/4041421"
  }

  ,
  {
    new: false,
    id: 37,
    title: "Blue Tweed GG Blazer",
    img: "img/outerwear/gg.jpg",
    price: 4980,
    type: "outerwear",
    company: "Gucci",
    info: "Long sleeve cotton and wool-blend tweed blazer in blue. Logo pattern embroidered in pink throughout. Braiding and embroidering in off-white throughout. Crewneck collar. Button closure at front. Patch pockets at chest and waist. Silk lining in pink. Carved enamel and metal hardware in blue, pink, and gold-tone. ",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.ssense.com/en-ca/women/product/marques-almeida/blue-denim-asymmetric-jacket/4032361"
  }
  ,
  {
    new: false,
    id: 38,
    title: "Pink Crushed Velvet 3D Coat",
    img: "img/outerwear/pinkcoat.jpg",
    price: 2750,
    type: "outerwear",
    company: "Balenciaga",
    info: "Long sleeve velvet coat in pink. Notched lapel collar. Button closure at front. Welt pockets at waist. Logo flag at side-seam. Modified shoulder pads. ",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.ssense.com/en-ca/women/product/vetements/pink-down-puffer-jacket/4161541"
  }
  ,
  {
    new: false,
    id: 39,
    title: "Blue Check Wool Hourglass Blazer",
    img: "img/outerwear/blazer.jpg",
    price: 3600,

    type: "outerwear",
    company: "Balenciaga  ",
    info: "Long sleeve virgin wool blazer featuring check pattern in tones of blue, green, and grey. Notched lapel collar. Button closure at front. Flap pockets at waist. Four-button surgeon's cuffs. Cupro lining in black.   ",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.ssense.com/en-ca/women/product/off-white/black-scaffolding-bomber-vest/4116111"
  }
  ,
  {
    new: false,
    id: 40,
    title: "Black Scaffolding Vest",
    img: "img/outerwear/vest.jpg",
    price: 1850,
    type: "outerwear",
    company: "Off-White",
    info:
      "Sleeveless padded nylon satin vest in black. Rib knit elasticized stand collar and hem. Two-way zip closure at front. Zippered pocket at chest. Zippered pocket featuring paperclip hardware, rubberized logo patch and welt pockets at waist. Logo printed in white at back. Single-button placket at hem. Nylon satin lining in orange. Tonal and antiqued gunmetal-tone hardware. ",
    inCart: false,
    count: 0,
    total: 0,
    url: "https://www.ssense.com/en-ca/women/product/off-white/black-scaffolding-bomber-vest/4116111"
  }
];

export const detailProduct = {
  new: false,
  id: 1,
  title: "Google Pixel - Black",
  img: "img/dresses/ceres.jpg",
  price: 10,
  company: "google",
  info:
    "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  inCart: false,
  count: 0,
  total: 0
};
